/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Password } from './password'
import { SelectApplication } from './app'
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class PasswordService {
    private users$: SelectApplication;
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    uPassword(id, password): Promise<Password> {
        return this.httpmanagerService.HttpPut('spassword', JSON.stringify(password), id).then(data => {
            return data;
        })
    }
    allApplicationView(): Promise<SelectApplication[]> {
        return this.httpmanagerService.HttpGet('cApplication', "").then(data => {
            return data.data;
        })
    }
    getUsers() {
        return this.users$;
    }
    setApplications(data) {
        let users = this.users$;
        if (users != data) {
            this.users$ = data;
        } else {
            this.users$ = (users);
        }
    }
    removeApplication(user) {
        let users = this.users$;
        if (users != user) {
            this.users$ = user;
        } else {
            this.users$ = users;
        }
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/password/password.service.ts